// extracted by mini-css-extract-plugin
module.exports = {"contactinfo":"contact-module--contactinfo--204AI","link":"contact-module--link--1J7T4 link--genericlink--3PIXe"};